import React from 'react';

const ChatgptConnectionPage = React.lazy(() => import('pages/ChatGPT/ChatgptConnectionPage'));
const ChatgptPage = React.lazy(() => import('pages/ChatGPT/ChatgptPage'));

const routes = [
  { path: '/chatgpt-connection', exact: true, name: 'Khai báo kết nối ChatGPT', function: 'SYS_CHATGPT_CONFIG', component: ChatgptConnectionPage },
  { path: '/chatgpt', exact: true, name: 'Hỗ trợ sản phẩm & tư vấn', function: ['SYS_CHATGPT_CHAT', 'MD_PRODUCT_VIEW', 'ST_PRODUCT_PRICE_INVENTORY_VIEW'], component: ChatgptPage },
];

export default routes;
